<template>
    <div class="mt-4">
        <engraving-modal v-if="isEngravingProduct" :product="product" />
    </div>
</template>

<script>
import EngravingModal from '@/components/product/EngravingModal';

export default {
    name: 'customerInfo',
    props: [
      'product',
    ],
    components: {
        EngravingModal,
    },
    computed: {
        isEngravingProduct() {
            return this.product.attributes.de.engraving ? true : false;
        }
    },
};
</script>

<style scoped lang="stylus">
    @import '~vuetify/src/stylus/settings/_variables.styl';
    .full-width {
        width: 100%;
        padding-left: 5px;
    }
    .full-width >>> .v-btn__content {
        justify-content: left;
        margin: 0;
    }

    .v-btn {
        padding: 4px 5px;
        height: 36px;
        @media(min-width: $grid-breakpoints.lg) {
            padding: 5px 7px;
            height: 47px;
        }
    }

</style>
